import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import routes from './routes';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './store';
import './styles/index.scss';
import Navbar from './components/navbar/navbar';
import { LoginModalProvider } from './loginModalProvider';
import LocationModal from './routes/landing-page/components/locationModal/locationModal';
import Footer from './routes/landing-page/components/footer/footer';
import mixpanel from 'mixpanel-browser';
 
// Near entry of your product, init Mixpanel
mixpanel.init("de275a2eddc40d592e68e38436407f7a", {
  debug: true,
  track_pageview: true,
  persistence: "localStorage",
});

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <LoginModalProvider>
        <Navbar />
        <LocationModal/>
        <div className='flex flex-col flex-1 app-content-container min-h-screen'>
          {routes}
        </div>
        <Footer />
        <Toaster />
      </LoginModalProvider>
    </Router>
  </Provider>,
  document.getElementById('app'),
);